<app-crud-list [observabledata]="observabledata"
               [displayedColumns]="displayedcolumns"
               [postTreatmentCallback]="getPostTreatmentCallback()"
               [idColumnName]="'id'"
               [entityroot]="entityroot"
               [deleteEntityHandler]="deleteEntityHandler()"
               [removePostTreatmentHandler]="deletePostTreatmentHandler()"
               [listEditPathCallback]="getListEditPathCallback()">
</app-crud-list>
